import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { ReservationProvider } from "./context/ReservationContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Fotos from "./pages/Fotos";
import Menu from "./pages/Menu";
import Contact from "./pages/Contact";
import Locatie from "./pages/Locatie";
import Private from "./pages/Private";
import SpinWheel from "./pages/SpinWheel";
import Events from "./pages/Events";
import ReservationModal from "./components/ReservationModal";

function SplashScreen({ onClose }) {
  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/80 backdrop-blur-sm" onClick={onClose} data-testid="splash-overlay">
      <div className="relative max-w-lg mx-4 flex flex-col items-center" onClick={e => e.stopPropagation()}>
        <img
          src="https://customer-assets-lxgj4vgw.emergentagent.net/job_6c1e1185-4e2b-4a47-b7ad-68a7aff64ff4/artifacts/cbiphvd1_ChatGPT%20Image%205%20sep%202026%2C%2014_22_38.png"
          alt="BARBAAR Dinner & Vibes"
          className="w-full rounded-sm shadow-2xl"
          data-testid="splash-image"
        />
        <button
          onClick={onClose}
          className="mt-5 px-10 py-3 bg-[#C8A46A] text-[#0A0A0A] font-body text-sm tracking-[0.15em] uppercase hover:bg-[#b8944a] transition-all duration-300"
          data-testid="splash-continue-btn"
        >
          Doorgaan naar de website
        </button>
      </div>
    </div>
  );
}

function AppContent({ reservationOpen, setReservationOpen }) {
  const location = useLocation();
  const [showSplash, setShowSplash] = useState(true);
  const isWheel = location.pathname === '/wheel';

  return (
    <>
      {showSplash && !isWheel && <SplashScreen onClose={() => setShowSplash(false)} />}
      {!isWheel && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/fotos" element={<Fotos />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/private" element={<Private />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/locatie" element={<Locatie />} />
        <Route path="/wheel" element={<SpinWheel />} />
      </Routes>
      {!isWheel && <Footer />}
      <ReservationModal open={reservationOpen} onClose={() => setReservationOpen(false)} />
    </>
  );
}

function App() {
  const [reservationOpen, setReservationOpen] = useState(false);

  return (
    <LanguageProvider>
      <ReservationProvider value={{ open: () => setReservationOpen(true) }}>
        <div className="App min-h-screen bg-[#0A0A0A]">
          <BrowserRouter>
            <AppContent reservationOpen={reservationOpen} setReservationOpen={setReservationOpen} />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </ReservationProvider>
    </LanguageProvider>
  );
}

export default App;
